var map = {
	"./aha24-icon.svg": 7061,
	"./aha`24-copy.svg": 2347,
	"./aha`24.svg": 2419,
	"./aha`25-mini.svg": 2418,
	"./arrow-left.svg": 6006,
	"./border-lines.svg": 1845,
	"./burger.svg": 6630,
	"./calendar.svg": 9671,
	"./card-rounded-corner.svg": 8023,
	"./category.svg": 4657,
	"./community.svg": 8952,
	"./csc-logo-35.svg": 3111,
	"./gitex.svg": 1192,
	"./gplc-eps-mini.svg": 5350,
	"./gplc-eps.svg": 9862,
	"./gpt-icon.svg": 8822,
	"./header-bg.svg": 7046,
	"./icon-search.svg": 2335,
	"./live.svg": 9711,
	"./loading.svg": 9803,
	"./logo-MM.svg": 3635,
	"./logo.svg": 160,
	"./mdi-chevron-down.svg": 3390,
	"./mm-icon.svg": 7551,
	"./no-image.svg": 2432,
	"./pdf-com.svg": 5629,
	"./qr-2.svg": 9845,
	"./qr-code-old.svg": 6774,
	"./qr-code.svg": 9866,
	"./rounded-corner.svg": 2438,
	"./share-solid.svg": 7120,
	"./share.svg": 5186,
	"./tail.svg": 3487,
	"./translate.svg": 7085,
	"./voice.svg": 7073,
	"./wave-bottom.svg": 4618,
	"./wave.svg": 9122,
	"./waves.svg": 9466
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2329;